<template>
    <div>
        <PatientHeader :patient="patient" :carehomeid="carehomeid"></PatientHeader>
        <br />
        <ul class="nav nav-tabs">
            <li class="active"><a href="#home" data-toggle="tab">Orders</a></li>
            <li><a href="#profile" data-toggle="tab">Med Profile</a></li>
            <ul class="nav nav-pills">
                <!--<li>
                    <router-link :to="{ name: 'charts', params: { carehomeid: patient.carehomeId, wardid: patient.wardId, patientid : patient.id }}">
                        Print Reports
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'patient-edit', params: { carehomeid:  patient.carehomeId, patientid : patient.id }}">
                        Edit Details
                    </router-link>
                </li>-->
            </ul>

        </ul>
        <!--<div style="border:3px solid; border-radius:20px; padding:2px; padding-right:13px; display:inline-block" class="text-danger">
            <span class="fa-stack fa-1x">
                <i class="fa fa-repeat fa-stack-1x text-warning"></i>
                <small><strong class="fa-stack-1x" style="margin-left:12px; margin-top:3px">5</strong></small>
            </span>                                                                    
            <span class="fa-stack fa-1x text-danger" style="margin-left:0px">          
                <i class="fa fa-exclamation-triangle fa-stack-1x"></i>                 
                <small><strong class="fa-stack-1x" style="margin-left:12px; margin-top:3px">2</strong></small>
            </span>                                                                    
            <span class="fa-stack fa-1x text-success" style="margin-left:0px">         
                <i class="fa fa-check fa-stack-1x"></i>                                
                <small><strong class="fa-stack-1x" style="margin-left:12px; margin-top:3px">5</strong></small>
            </span>
        </div>-->
        <div id="myTabContent" class="tab-content">
            <div class="tab-pane fade active in" id="home">
                <PatientOrderItems :patient="patient" start-date="2017-10-29" end-date="2017-11-25"></PatientOrderItems>
            </div>
            <div class="tab-pane fade" id="profile">
                <MedProfileForm :patient="patient" start-date="2017-10-01" end-date="2017-10-28"></MedProfileForm>
            </div>
        </div>

    </div>
</template>


<script>
    import PatientHeader from "../../appcontrols/patientHeader/patientHeader.scp.html"
    import PatientOrderItems from "../../appcontrols/PatientOrderItems/PatientOrderItems.scp.html"
    import MedProfileForm from "../../appcontrols/MedProfileForm/MedProfileForm.scp.html"

    //import ReorderForm from "../appcontrols/reorderForm/reorderform.scp.html"
    //import { ReorderItemDto } from "./../../dto/ReorderItemDto"
    //import { DrugDto } from "./../../dto/DrugDto"
    import { PatientDto } from "./../../../dto/PatientDto"
    //import { WardCycleDto } from "./../../dto/Dtos"
    import Dal from "./../../../scripts/dataaccess"
    //import { FormElementController, FormValidator, FormElementValidator, StringValidators } from './../../scripts/formcontrols'


    export default {
        props: ['carehomeid', 'id'],
        data: function () {
            return {
                patientId: {},
                patient: new PatientDto(),
                cycles: []
            }
        },
        mounted: function () {
            this.patientId = this.$route.params.id;
            var dal = new Dal();
            dal.GetPatient(this.patientId).then(data => {
                this.patient = data;
                console.log("PAtient", this.patient);
                dal.GetWardCycles(this.patient.wardId).then(cycles => {
                    this.cycles = cycles;
                })
            });

        }
        , components: {
            PatientHeader
            , PatientOrderItems
            , MedProfileForm
        }
    }
</script>


// WEBPACK FOOTER //
// carehome-patient-main.scp.html?0ba0e9e3